<basic-input
  [control]="control"
  [icon]="icon"
  [label]="label"
  [id]="id"
  [required]="required"
  [placeholder]="'Mr. John Doe'"
  (onBlurValueChange)="formatBlur()"
  [allowClearButton]="allowClearButton"
  [fieldType]="basicFieldType"
  [mode]="mode"
  [autofocus]="autofocus"
  [fullnameParts]="fullnameParts"
  [isFullname]="true"
  [showFullnameSegments]="showSegments"
  [clearFullnameParts]="clearFullnameParts.bind(this)"
  (onKeydown)="deleteChar($event)"
></basic-input>
